// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__2U1mz","dead_center":"Page_dead_center__3-jRy","primary":"Page_primary__76WEj","master_detail":"Page_master_detail__3zlT9","secondary":"Page_secondary__36orY"};